/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Prosím přiložte fotografii produktu a fotografii vady`
};

const da_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Vedhæft venligst et billede af produktet samt fejlen`
};

const de_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Bitte fügen Sie ein Foto des Produkts und des Mangels als Anhang bei`
};

const en_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Please attach a photo of the product as well as the defect`
};

const es_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor, adjunta una foto del producto y del defecto`
};

const fr_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Merci de nous fournir en pièce jointe une photo du produit ainsi que du défaut`
};

const hu_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Kérjük, mellékeld a termék fotóját és a hiba fotóját`
};

const it_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Fornisci in allegato una foto del prodotto e del difetto`
};

const nl_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Voeg een foto van het product en het defect toe`
};

const pl_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Prosimy o załączenie zdjęcia produktu oraz wady`
};

const pt_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor, anexe uma foto do produto e do defeito`
};

const sv_contact_helper_messages_confirmation_faulty_product = /** @type {(inputs: {}) => string} */ () => {
	return `Vänligen bifoga en bild på produkten och felet`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const contact_helper_messages_confirmation_faulty_product = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_helper_messages_confirmation_faulty_product(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_helper_messages_confirmation_faulty_product", locale)
	if (locale === "cs") return cs_contact_helper_messages_confirmation_faulty_product(inputs)
	if (locale === "da") return da_contact_helper_messages_confirmation_faulty_product(inputs)
	if (locale === "de") return de_contact_helper_messages_confirmation_faulty_product(inputs)
	if (locale === "en") return en_contact_helper_messages_confirmation_faulty_product(inputs)
	if (locale === "es") return es_contact_helper_messages_confirmation_faulty_product(inputs)
	if (locale === "fr") return fr_contact_helper_messages_confirmation_faulty_product(inputs)
	if (locale === "hu") return hu_contact_helper_messages_confirmation_faulty_product(inputs)
	if (locale === "it") return it_contact_helper_messages_confirmation_faulty_product(inputs)
	if (locale === "nl") return nl_contact_helper_messages_confirmation_faulty_product(inputs)
	if (locale === "pl") return pl_contact_helper_messages_confirmation_faulty_product(inputs)
	if (locale === "pt") return pt_contact_helper_messages_confirmation_faulty_product(inputs)
	return sv_contact_helper_messages_confirmation_faulty_product(inputs)
};
export { contact_helper_messages_confirmation_faulty_product as "contact.helper_messages.confirmation.faulty_product" }